/* eslint react/jsx-props-no-spreading: 0 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Label, Input } from 'reactstrap';
import { getI18nUtils } from '../../../i18n/i18n-utils';
import { Dictionaries } from '../../../i18n/i18n-config';

interface FormikInputCheckboxProps {
  name: string;
  id?: string;
  required?: boolean;
  formik: any;
  intlKey?: string;
  className?: string;
  dictionary: Partial<Dictionaries>;
}

function FormikInputCheckbox({
  name,
  id,
  required,
  intlKey,
  formik,
  className,
  dictionary,
}: FormikInputCheckboxProps): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <div className={`form-check form-check-inline ${className}`}>
      <Label for={name} check>
        <Input
          type="checkbox"
          id={id || name}
          required={!!required}
          checked={formik.getFieldProps(name)?.value}
          {...formik.getFieldProps(name)}
        />{' '}
        {formatMessage({ id: intlKey || name })}
      </Label>
    </div>
  );
}

export default FormikInputCheckbox;
